import { useTranslation } from "react-i18next";
import { Alert, Box, Button, Typography } from "@mui/material";
import { createFileRoute, useNavigate } from "@tanstack/react-router";

export const Route = createFileRoute("/auth-error")({
  validateSearch: (search: Record<string, unknown>) => ({
    error: search.error as string | undefined,
    error_description: search.error_description as string | undefined,
  }),
  component: AuthErrorPage,
});

function AuthErrorPage() {
  const { t } = useTranslation();
  const search = Route.useSearch();
  const navigate = useNavigate();

  const errorCode = search.error || "unknown_error";
  const errorDescription =
    search.error_description || t("text_authentication_error_generic", { ns: "_common" });

  const handleRetry = () => {
    void navigate({ to: "/app", replace: true });
  };

  return (
    <Box
      width="100%"
      height="100vh"
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      p={4}
    >
      <Box maxWidth={600} width="100%">
        <Typography variant="h4" gutterBottom>
          {t("text_authentication_error", { ns: "_common" })}
        </Typography>

        <Alert severity="error" sx={{ mb: 3 }}>
          <Typography variant="body1" fontWeight="bold" gutterBottom>
            {errorCode}
          </Typography>
          <Typography variant="body2">{errorDescription}</Typography>
        </Alert>

        <Button variant="contained" color="primary" onClick={handleRetry}>
          {t("action_try_again", { ns: "_action" })}
        </Button>
      </Box>
    </Box>
  );
}
